import { render, staticRenderFns } from "./BackpackViewer.vue?vue&type=template&id=6a37d346&"
import script from "./BackpackViewer.vue?vue&type=script&lang=js&"
export * from "./BackpackViewer.vue?vue&type=script&lang=js&"
import style0 from "./BackpackViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports